import { render, staticRenderFns } from "./ImageInput2.vue?vue&type=template&id=2185654d"
import script from "./ImageInput2.vue?vue&type=script&lang=js"
export * from "./ImageInput2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports